import { ExpandoDirection, ExpandoWidget } from '@tableau/widgets';
import * as React from 'react';
import { Messages } from '../../../codegen/Localize';
import { classes, cssClass, flexColumnStyle, flexRowStyle } from '../../../style';
import { imgPath } from '../../utilities/ImgUrl';
import { CommonStyles } from '../CommonStyles';

export const formattingHintsExpandoTestId = 'formatting-hints-toggle-button';

export type FormattingHintsProps = {
  readonly showProjectImageHint?: boolean;
};

export type FormattingHintsState = {
  readonly showHints: boolean;
};

const cssPrefix = 'formattingHints';

const formattingHintsRoot = cssClass(cssPrefix, 'formattingHints', {
  padding: 2
});

const formattingHelpRoot = cssClass(cssPrefix, 'formattingHelp', flexRowStyle, {
  paddingTop: CommonStyles.Sizes.DefaultSpace
});

const formattingColumnLeft = cssClass(cssPrefix, 'formattingColumnLeft', flexColumnStyle, {
  width: 120,
  $nest: {
    'div': { padding: CommonStyles.Sizes.DefaultSpace }
  }
});

const formattingColumnRight = cssClass(cssPrefix, 'formattingColumnRight', flexColumnStyle, {
  flex: 1,
  $nest: {
    'div': { padding: CommonStyles.Sizes.DefaultSpace }
  }
});

const formattingHeader = cssClass(cssPrefix, 'formattingHeader', {
  padding: CommonStyles.Sizes.DefaultSpace,
  backgroundColor: CommonStyles.Colors.Grey230
});

const imageHintIcon = cssClass(cssPrefix, 'imageHintIcon', {
  height: '19px',
  width: '19px',
  verticalAlign: 'middle'
});

export class FormattingHints extends React.PureComponent<FormattingHintsProps, FormattingHintsState> {

  constructor(props: FormattingHintsProps) {
    super(props);
    this.state = {
      showHints: false
    };
  }

  private renderHintsMessages(): JSX.Element {
    /* eslint-disable jsx-a11y/anchor-is-valid */
    /* eslint-disable jsx-a11y/alt-text */
    return (
      <div className={classes(formattingHelpRoot, 'tb-formatting-hints-table')}>
        <div className={classes(formattingColumnLeft, 'tb-formatting-hints-column-left')}>
          <div className={formattingHeader}>{Messages.formattingHintsColumnExample()}</div>
          <div><a>{Messages.formattingHintsLink()}</a></div>
          <div><strong>{Messages.formattingHintsBold()}</strong></div>
          <div><em>{Messages.formattingHintsItalics()}</em></div>
          <div><ins>{Messages.formattingHintsUnderline()}</ins></div>
          <div><img src={imgPath('image_hint_icon.svg')} className={imageHintIcon}/>{Messages.formattingHintsImage()}</div>
        </div>
        <div className={classes(formattingColumnRight, 'tb-formatting-hints-column-right')}>
          <div className={formattingHeader}>{Messages.formattingHintsColumnMarkup()}</div>
          <div>{`"${Messages.formattingHintsLink()}":http://www.example.com`}</div>
          <div>{`*${Messages.formattingHintsBold()}*`}</div>
          <div>{`_${Messages.formattingHintsItalics()}_`}</div>
          <div>{`+${Messages.formattingHintsUnderline()}+`}</div>
          <div>{'!http://www.example.com/image.png!'}</div>
          {this.props.showProjectImageHint ? <div>{Messages.formattingHintsProjectImage()}</div> : null}
        </div>
      </div>
    );
  }

  private toggleFormattingHints = () => {
    this.setState({ showHints: !this.state.showHints });
  }

  public render(): JSX.Element {

    const hintsLabel = this.state.showHints ? Messages.hideFormattingHints() : Messages.showFormattingHints();
    const expandoClass = this.state.showHints ? 'tb-hide-formatting-hints' : 'tb-show-formatting-hints';
    return (
      <div className={formattingHintsRoot} tb-test-id="formatting-hints-editable-textarea">
        <ExpandoWidget
          label={hintsLabel}
          className={expandoClass}
          testId={formattingHintsExpandoTestId}
          isExpanded={this.state.showHints}
          onExpand={this.toggleFormattingHints}
          onCollapse={this.toggleFormattingHints}
          direction={ExpandoDirection.Down}>
            {this.state.showHints ? this.renderHintsMessages() : null}
        </ExpandoWidget>
      </div>
    );
  }
}
